import {isEmptyValue} from '../../common/utils.js'
import handleListSelection from '../../common/handleListSelection.js'
import {PRODUCT_DETAIL_SUPPLIERS_PANEL} from '../../common/constants/Products.js'
import LinkButton from '../../common/components/Link/LinkButton.js'
import Currency, {
  MAX_FRACTION_DIGITS,
} from '../../common/components/Currency.js'
import Quantity from '../../common/components/Quantity.js'
import Checkbox from '../../common/components/Checkbox.js'
import ButtonLink from '../../common/components/Button/ButtonLink.js'
import {plural} from '../../common/components/Plural.js'
import {
  supplierIDSelector,
  poItemReceivedSelector,
  poItemNameSelector,
  poItemSKUSelector,
  poItemQuantitySelector,
  poItemSupplierSKUSelector,
  poItemPhysicalOnHandSelector,
  poItemCommittedSelector,
  poItemPOTotalCommittedSelector,
  poItemUnitPriceSelector,
  poItemDiscountAmountSelector,
  poItemTotalPriceSelector,
  poItemSupplierNoteSelector,
} from '../../data/pos.js'
import {supplierLeadTimeSelector} from '../../data/products.js'
import {productDetailURLSelector} from '../ProductDetailPage/productDetailSelectors.js'
import {showEditPOItemModal} from '../PurchaseOrderListPage/Modals/EditPOItemModal.js'
import {showRemovePOItemModal} from '../PurchaseOrderListPage/Modals/RemovePOItemModal.js'
import {updatePODetailForm} from './poDetailActions.js'
import {dispatch, useSelector} from '../../store.js'
import Icon from '../../common/icons/Icon.js'
import {Draggable, DragHandle} from '../../common/components/DragAndDrop.js'

export default function Item({
  index,
  poID,
  poItemID,
  form,
  isPOLocked,
  hasPOFinancialsPermission,
}) {
  const sku = useSelector((state) => poItemSKUSelector(state, {poID, poItemID}))
  const supplierID = useSelector((state) => supplierIDSelector(state, {poID}))
  const received = useSelector((state) =>
    poItemReceivedSelector(state, {poID, poItemID}),
  )
  const name = useSelector((state) =>
    poItemNameSelector(state, {poID, poItemID}),
  )
  const quantity = useSelector((state) =>
    poItemQuantitySelector(state, {poID, poItemID}),
  )
  const supplier_note = useSelector((state) =>
    poItemSupplierNoteSelector(state, {poID, poItemID}),
  )
  const supplier_sku = useSelector((state) =>
    poItemSupplierSKUSelector(state, {poID, poItemID}),
  )
  const physical_on_hand = useSelector((state) =>
    poItemPhysicalOnHandSelector(state, {poID, poItemID}),
  )
  const committed = useSelector((state) =>
    poItemCommittedSelector(state, {poID, poItemID}),
  )
  const total_po_committed = useSelector((state) =>
    poItemPOTotalCommittedSelector(state, {
      poID,
      poItemID,
    }),
  )
  const unit_price = useSelector((state) =>
    poItemUnitPriceSelector(state, {poID, poItemID}),
  )
  const discount_amount = useSelector((state) =>
    poItemDiscountAmountSelector(state, {poID, poItemID}),
  )
  const total_price = useSelector((state) =>
    poItemTotalPriceSelector(state, {poID, poItemID}),
  )
  const productDetailURL = useSelector((state) =>
    productDetailURLSelector(state, {sku}),
  )
  const supplier_lead_time = useSelector((state) =>
    supplierLeadTimeSelector(state, {sku, supplierID}),
  )

  return (
    <Draggable El="tr" id={poItemID} uiIndex={index}>
      <td className="table__td padding-right-0">
        <div className="wrap--draggable-line-item flex">
          <DragHandle className="" />
          <Checkbox
            className="margin-bottom-0"
            checked={form.selectedItemIDs.includes(poItemID)}
            onClick={(checked, event) =>
              updatePODetailForm({
                selectedItemIDs: handleListSelection({
                  value: poItemID,
                  isSelected: checked,
                  isShiftKey: event.shiftKey,
                  selected: form.selectedItemIDs,
                  list: form.itemIDs,
                }),
              })
            }
            disabled={isPOLocked}
          />
        </div>
      </td>
      <td className="table__td table__td--md">
        <LinkButton className="darker word-breaker" href={productDetailURL}>
          <strong className="block">{name}</strong>
          <span className="block">{sku}</span>
        </LinkButton>
      </td>
      <td className="table__td table__td--md">
        <LinkButton
          className="darker"
          href={`${productDetailURL}/${PRODUCT_DETAIL_SUPPLIERS_PANEL}`}
        >
          <strong>{supplier_sku}</strong>
        </LinkButton>
        {supplier_note ? (
          <>
            <div className="divider--top sm fs-n1 lh-md margin-bottom-1">
              <div className="fs-n1 ws-pre-wrap">{supplier_note}</div>
            </div>
            <ButtonLink
              className="fs-n2 v-align-base"
              onClick={() =>
                showEditPOItemModal(poID, [poItemID], 'supplier_note')
              }
            >
              <span>Edit note</span>
            </ButtonLink>
          </>
        ) : (
          <div className="margin-top-1">
            <ButtonLink
              className="fs-n2 v-align-base"
              onClick={() =>
                showEditPOItemModal(poID, [poItemID], 'supplier_note')
              }
            >
              <span>Add a note</span>
            </ButtonLink>
          </div>
        )}
      </td>

      <td className="table__td table__td--md align-right">
        <ButtonLink
          className="darker lh-sm v-align-top border-underline"
          onClick={() => showEditPOItemModal(poID, [poItemID], 'quantity')}
          disabled={isPOLocked}
        >
          <Quantity value={quantity} />
        </ButtonLink>
      </td>
      <td className="table__td table__td--md align-right">
        <Quantity value={received} />
      </td>
      <td className="table__td table__td--md align-right">
        {!isEmptyValue(physical_on_hand) ? (
          <Quantity value={physical_on_hand} />
        ) : (
          '-'
        )}
      </td>
      <td className="table__td table__td--md align-right">
        {!isEmptyValue(committed) ? <Quantity value={committed} /> : '-'}
      </td>
      <td className="table__td table__td--md align-right">
        {!isEmptyValue(total_po_committed) ? (
          <Quantity value={total_po_committed} />
        ) : (
          '-'
        )}
      </td>
      {hasPOFinancialsPermission && (
        <td className="table__td table__td--md align-right">
          <ButtonLink
            className="darker lh-sm v-align-top border-underline"
            onClick={() => showEditPOItemModal(poID, [poItemID], 'unit_price')}
            disabled={isPOLocked}
          >
            <Currency
              value={unit_price}
              options={{maximumFractionDigits: MAX_FRACTION_DIGITS}}
            />
          </ButtonLink>
        </td>
      )}
      <td className="table__td table__td--md">
        {supplier_lead_time
          ? plural(supplier_lead_time)`${supplier_lead_time} day${['s']}`
          : ''}
      </td>
      {hasPOFinancialsPermission && (
        <>
          <td className="table__td table__td--md align-right">
            <ButtonLink
              className="darker lh-sm v-align-top border-underline"
              onClick={() =>
                showEditPOItemModal(poID, [poItemID], 'discount_amount')
              }
              disabled={isPOLocked}
            >
              <Currency value={discount_amount} />
            </ButtonLink>
          </td>
          <td className="table__td table__td--md align-right">
            <Currency value={total_price} />
          </td>
        </>
      )}
      <td className="table__td table__td--md align-right">
        <ButtonLink
          title="Remove line from PO"
          className="no-underline"
          onClick={() => dispatch(showRemovePOItemModal(poID, [poItemID]))}
          disabled={isPOLocked}
        >
          <Icon name="trash" className="fs-00" />
        </ButtonLink>
      </td>
    </Draggable>
  )
}
